import { render, staticRenderFns } from "./final-plat-index.vue?vue&type=template&id=9332d9cc"
import script from "./final-plat-index.vue?vue&type=script&lang=js"
export * from "./final-plat-index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports